import type { FC, SVGProps } from "react";

export const EmptyStateIllustration: FC<
	SVGProps<SVGSVGElement> & { label?: string }
> = ({ label = "Ilustração de estado vazio do CNH", ...props }) => (
	<svg
		fill="none"
		height="104"
		role="img"
		viewBox="0 0 104 104"
		width="104"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
		aria-label={label}
	>
		<rect
			fill="url(#paint0_linear_14002_4419)"
			height="104"
			rx="52"
			width="104"
		/>
		<g filter="url(#filter0_dd_14002_4419)">
			<path
				d="M40 32.75H56C56.1212 32.75 56.2375 32.7981 56.3232 32.8838L67.1162 43.6768C67.2019 43.7625 67.25 43.8788 67.25 44V68C67.25 69.7949 65.7949 71.25 64 71.25H40C38.2051 71.25 36.75 69.7949 36.75 68V36C36.75 34.2051 38.2051 32.75 40 32.75Z"
				stroke="#D5D7DA"
				strokeWidth="1.5"
			/>
			<path
				d="M56 32.5V40C56 42.2091 57.7909 44 60 44H67.5"
				stroke="#D5D7DA"
				strokeWidth="1.5"
			/>
		</g>
		<defs>
			<filter
				colorInterpolationFilters="sRGB"
				filterUnits="userSpaceOnUse"
				height="46"
				id="filter0_dd_14002_4419"
				width="46"
				x="29"
				y="30"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					result="hardAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feMorphology
					in="SourceAlpha"
					operator="erode"
					radius="1"
					result="effect1_dropShadow_14002_4419"
				/>
				<feOffset dy="1" />
				<feGaussianBlur stdDeviation="1" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.1 0"
				/>
				<feBlend
					in2="BackgroundImageFix"
					mode="normal"
					result="effect1_dropShadow_14002_4419"
				/>
				<feColorMatrix
					in="SourceAlpha"
					result="hardAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset dy="1" />
				<feGaussianBlur stdDeviation="1.5" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.1 0"
				/>
				<feBlend
					in2="effect1_dropShadow_14002_4419"
					mode="normal"
					result="effect2_dropShadow_14002_4419"
				/>
				<feBlend
					in="SourceGraphic"
					in2="effect2_dropShadow_14002_4419"
					mode="normal"
					result="shape"
				/>
			</filter>
			<linearGradient
				gradientUnits="userSpaceOnUse"
				id="paint0_linear_14002_4419"
				x1="52"
				x2="52"
				y1="0"
				y2="104"
			>
				<stop stopColor="#FAFAFA" />
				<stop offset="1" stopColor="#E9EAEB" />
			</linearGradient>
		</defs>
	</svg>
);
